import {
  LOAD_STAFF_ACCOMMODATION_REQUESTS,
  LOAD_STAFF_ACCOMMODATION_REQUESTS_SUCCESS,
  LOAD_STAFF_ACCOMMODATION_REQUESTS_ERROR,
  LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL,
  LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL_SUCCESS,
  LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL_ERROR,
  LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY,
  LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY_SUCCESS,
  LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY_ERROR,
  APPROVE_ACCOMMODATION_REQUEST,
  APPROVE_ACCOMMODATION_REQUEST_SUCCESS,
  APPROVE_ACCOMMODATION_REQUEST_ERROR,
  DENY_ACCOMMODATION_REQUEST,
  DENY_ACCOMMODATION_REQUEST_SUCCESS,
  DENY_ACCOMMODATION_REQUEST_ERROR,
  BYPASS_APPROVE_ACCOMMODATION_REQUEST,
  BYPASS_APPROVE_ACCOMMODATION_REQUEST_SUCCESS,
  BYPASS_APPROVE_ACCOMMODATION_REQUEST_ERROR,
  ADD_ACCOMMODATION_NOTE,
  ADD_ACCOMMODATION_NOTE_SUCCESS,
  ADD_ACCOMMODATION_NOTE_ERROR,
  REVIEW_ACCOMMODATION_DOCUMENT,
  REVIEW_ACCOMMODATION_DOCUMENT_SUCCESS,
  REVIEW_ACCOMMODATION_DOCUMENT_ERROR,
  UPLOAD_STAFF_ACCOMMODATION_DOCUMENT,
  UPLOAD_STAFF_ACCOMMODATION_DOCUMENT_SUCCESS,
  UPLOAD_STAFF_ACCOMMODATION_DOCUMENT_ERROR,
  CREATE_ACCOMMODATION_REQUEST_ON_BEHALF,
  CREATE_ACCOMMODATION_REQUEST_ON_BEHALF_SUCCESS,
  CREATE_ACCOMMODATION_REQUEST_ON_BEHALF_ERROR,
  LOAD_STAFF_ACCOMMODATION_PLAN,
  LOAD_STAFF_ACCOMMODATION_PLAN_SUCCESS,
  LOAD_STAFF_ACCOMMODATION_PLAN_ERROR,
  CREATE_ACCOMMODATION_PLAN,
  CREATE_ACCOMMODATION_PLAN_SUCCESS,
  CREATE_ACCOMMODATION_PLAN_ERROR,
  UPDATE_ACCOMMODATION_PLAN,
  UPDATE_ACCOMMODATION_PLAN_SUCCESS,
  UPDATE_ACCOMMODATION_PLAN_ERROR,
  CREATE_ACCOMMODATION_LETTER,
  CREATE_ACCOMMODATION_LETTER_SUCCESS,
  CREATE_ACCOMMODATION_LETTER_ERROR,
  FINALISE_ACCOMMODATION_LETTER,
  FINALISE_ACCOMMODATION_LETTER_SUCCESS,
  FINALISE_ACCOMMODATION_LETTER_ERROR,
  DOWNLOAD_STAFF_ACCOMMODATION_LETTER,
  DOWNLOAD_STAFF_ACCOMMODATION_LETTER_SUCCESS,
  DOWNLOAD_STAFF_ACCOMMODATION_LETTER_ERROR,
  DOWNLOAD_ACCOMMODATION_DOCUMENT,
  DOWNLOAD_ACCOMMODATION_DOCUMENT_SUCCESS,
  DOWNLOAD_ACCOMMODATION_DOCUMENT_ERROR,
  SET_ACCOMMODATION_REQUESTS_FILTERS,
  RESET_STAFF_ACCOMMODATION_STATE,
  CLEAR_STAFF_ACCOMMODATION_REQUEST_DETAIL,
  LOAD_ACCOMMODATION_STATUSES,
  LOAD_ACCOMMODATION_STATUSES_SUCCESS,
  LOAD_ACCOMMODATION_STATUSES_ERROR,
  LOAD_ACCOMMODATION_DOCUMENT_STATUSES,
  LOAD_ACCOMMODATION_DOCUMENT_STATUSES_SUCCESS,
  LOAD_ACCOMMODATION_DOCUMENT_STATUSES_ERROR,
} from "./types";

const initialState = {
  requests: {
    data: [],
    totalCount: 0,
    loading: false,
    error: null,
    requestId: null,
  },
  requestDetail: {
    data: null,
    loading: false,
    error: null,
  },
  requestHistory: {
    data: [],
    loading: false,
    error: null,
  },
  accommodationPlan: {
    data: null,
    loading: false,
    error: null,
  },
  approving: false,
  approvingError: null,
  denying: false,
  denyingError: null,
  bypassApproving: false,
  bypassApprovingError: null,
  addingNote: false,
  addingNoteError: null,
  reviewingDocument: false,
  reviewingDocumentError: null,
  uploadingDocument: false,
  uploadingDocumentError: null,
  creatingOnBehalf: false,
  creatingOnBehalfError: null,
  creatingPlan: false,
  creatingPlanError: null,
  updatingPlan: false,
  updatingPlanError: null,
  creatingLetter: false,
  creatingLetterError: null,
  finalisingLetter: false,
  finalisingLetterError: null,
  downloadingLetter: false,
  downloadingLetterError: null,
  downloadingDocument: false,
  downloadingDocumentError: null,
  statuses: {
    data: [],
    loading: false,
    error: null,
  },
  documentStatuses: {
    data: [],
    loading: false,
    error: null,
  },
  filters: {},
};

const staffAccommodationsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Requests list
    case LOAD_STAFF_ACCOMMODATION_REQUESTS:
      return {
        ...state,
        requests: { ...state.requests, requestId: action.requestId, loading: true, error: null },
      };
    case LOAD_STAFF_ACCOMMODATION_REQUESTS_SUCCESS:
      if (action.requestId !== state.requests.requestId || state.requests.requestId == null) return state;
      return {
        ...state,
        requests: { ...state.requests, ...action.payload, loading: false, error: null, requestId: null },
      };
    case LOAD_STAFF_ACCOMMODATION_REQUESTS_ERROR:
      if (action.requestId !== state.requests.requestId || state.requests.requestId == null) return state;
      return {
        ...state,
        requests: { ...state.requests, data: [], totalCount: 0, loading: false, error: "Failed to load staff requests", requestId: null },
      };

    // Request detail
    case LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL:
      return {
        ...state,
        requestDetail: { ...state.requestDetail, loading: true, error: null },
      };
    case LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL_SUCCESS:
      return {
        ...state,
        requestDetail: { data: action.payload, loading: false, error: null },
      };
    case LOAD_STAFF_ACCOMMODATION_REQUEST_DETAIL_ERROR:
      return {
        ...state,
        requestDetail: { ...state.requestDetail, loading: false, error: "Failed to load request detail" },
      };

    // Request history
    case LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY:
      return {
        ...state,
        requestHistory: { ...state.requestHistory, loading: true, error: null },
      };
    case LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY_SUCCESS:
      return {
        ...state,
        requestHistory: { data: action.payload, loading: false, error: null },
      };
    case LOAD_STAFF_ACCOMMODATION_REQUEST_HISTORY_ERROR:
      return {
        ...state,
        requestHistory: { ...state.requestHistory, loading: false, error: "Failed to load history" },
      };

    // Approve request
    case APPROVE_ACCOMMODATION_REQUEST:
      return {
        ...state,
        approving: true,
        approvingError: null,
      };
    case APPROVE_ACCOMMODATION_REQUEST_SUCCESS:
      return {
        ...state,
        approving: false,
        requestDetail: { data: action.payload, loading: false, error: null },
      };
    case APPROVE_ACCOMMODATION_REQUEST_ERROR:
      return {
        ...state,
        approving: false,
        approvingError: "Failed to approve request",
      };

    // Deny request
    case DENY_ACCOMMODATION_REQUEST:
      return {
        ...state,
        denying: true,
        denyingError: null,
      };
    case DENY_ACCOMMODATION_REQUEST_SUCCESS:
      return {
        ...state,
        denying: false,
        requestDetail: { data: action.payload, loading: false, error: null },
      };
    case DENY_ACCOMMODATION_REQUEST_ERROR:
      return {
        ...state,
        denying: false,
        denyingError: "Failed to deny request",
      };

    // Bypass approve request
    case BYPASS_APPROVE_ACCOMMODATION_REQUEST:
      return {
        ...state,
        bypassApproving: true,
        bypassApprovingError: null,
      };
    case BYPASS_APPROVE_ACCOMMODATION_REQUEST_SUCCESS:
      return {
        ...state,
        bypassApproving: false,
        requestDetail: { data: action.payload, loading: false, error: null },
      };
    case BYPASS_APPROVE_ACCOMMODATION_REQUEST_ERROR:
      return {
        ...state,
        bypassApproving: false,
        bypassApprovingError: "Failed to bypass approve request",
      };

    // Add note
    case ADD_ACCOMMODATION_NOTE:
      return {
        ...state,
        addingNote: true,
        addingNoteError: null,
      };
    case ADD_ACCOMMODATION_NOTE_SUCCESS:
      return {
        ...state,
        addingNote: false,
        requestDetail: {
          ...state.requestDetail,
          data: {
            ...state.requestDetail.data,
            notes: [...(state.requestDetail.data?.notes || []), action.payload],
          },
        },
      };
    case ADD_ACCOMMODATION_NOTE_ERROR:
      return {
        ...state,
        addingNote: false,
        addingNoteError: "Failed to add note",
      };

    // Review document
    case REVIEW_ACCOMMODATION_DOCUMENT:
      return {
        ...state,
        reviewingDocument: true,
        reviewingDocumentError: null,
      };
    case REVIEW_ACCOMMODATION_DOCUMENT_SUCCESS:
      return {
        ...state,
        reviewingDocument: false,
      };
    case REVIEW_ACCOMMODATION_DOCUMENT_ERROR:
      return {
        ...state,
        reviewingDocument: false,
        reviewingDocumentError: "Failed to review document",
      };

    // Upload staff document
    case UPLOAD_STAFF_ACCOMMODATION_DOCUMENT:
      return {
        ...state,
        uploadingDocument: true,
        uploadingDocumentError: null,
      };
    case UPLOAD_STAFF_ACCOMMODATION_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploadingDocument: false,
      };
    case UPLOAD_STAFF_ACCOMMODATION_DOCUMENT_ERROR:
      return {
        ...state,
        uploadingDocument: false,
        uploadingDocumentError: "Failed to upload document",
      };

    // Create on behalf
    case CREATE_ACCOMMODATION_REQUEST_ON_BEHALF:
      return {
        ...state,
        creatingOnBehalf: true,
        creatingOnBehalfError: null,
      };
    case CREATE_ACCOMMODATION_REQUEST_ON_BEHALF_SUCCESS:
      return {
        ...state,
        creatingOnBehalf: false,
        requests: {
          ...state.requests,
          data: [action.payload, ...state.requests.data],
        },
      };
    case CREATE_ACCOMMODATION_REQUEST_ON_BEHALF_ERROR:
      return {
        ...state,
        creatingOnBehalf: false,
        creatingOnBehalfError: "Failed to create request on behalf",
      };

    // Accommodation plan
    case LOAD_STAFF_ACCOMMODATION_PLAN:
      return {
        ...state,
        accommodationPlan: { ...state.accommodationPlan, loading: true, error: null },
      };
    case LOAD_STAFF_ACCOMMODATION_PLAN_SUCCESS:
      return {
        ...state,
        accommodationPlan: { data: action.payload, loading: false, error: null },
      };
    case LOAD_STAFF_ACCOMMODATION_PLAN_ERROR:
      return {
        ...state,
        accommodationPlan: { ...state.accommodationPlan, loading: false, error: "Failed to load plan" },
      };

    // Create plan
    case CREATE_ACCOMMODATION_PLAN:
      return {
        ...state,
        creatingPlan: true,
        creatingPlanError: null,
      };
    case CREATE_ACCOMMODATION_PLAN_SUCCESS:
      return {
        ...state,
        creatingPlan: false,
        accommodationPlan: { data: action.payload, loading: false, error: null },
      };
    case CREATE_ACCOMMODATION_PLAN_ERROR:
      return {
        ...state,
        creatingPlan: false,
        creatingPlanError: "Failed to create plan",
      };

    // Update plan
    case UPDATE_ACCOMMODATION_PLAN:
      return {
        ...state,
        updatingPlan: true,
        updatingPlanError: null,
      };
    case UPDATE_ACCOMMODATION_PLAN_SUCCESS:
      return {
        ...state,
        updatingPlan: false,
        accommodationPlan: { data: action.payload, loading: false, error: null },
      };
    case UPDATE_ACCOMMODATION_PLAN_ERROR:
      return {
        ...state,
        updatingPlan: false,
        updatingPlanError: "Failed to update plan",
      };

    // Create letter
    case CREATE_ACCOMMODATION_LETTER:
      return {
        ...state,
        creatingLetter: true,
        creatingLetterError: null,
      };
    case CREATE_ACCOMMODATION_LETTER_SUCCESS:
      return {
        ...state,
        creatingLetter: false,
      };
    case CREATE_ACCOMMODATION_LETTER_ERROR:
      return {
        ...state,
        creatingLetter: false,
        creatingLetterError: "Failed to create letter",
      };

    // Finalise letter
    case FINALISE_ACCOMMODATION_LETTER:
      return {
        ...state,
        finalisingLetter: true,
        finalisingLetterError: null,
      };
    case FINALISE_ACCOMMODATION_LETTER_SUCCESS:
      return {
        ...state,
        finalisingLetter: false,
      };
    case FINALISE_ACCOMMODATION_LETTER_ERROR:
      return {
        ...state,
        finalisingLetter: false,
        finalisingLetterError: "Failed to finalise letter",
      };

    // Download letter
    case DOWNLOAD_STAFF_ACCOMMODATION_LETTER:
      return {
        ...state,
        downloadingLetter: true,
        downloadingLetterError: null,
      };
    case DOWNLOAD_STAFF_ACCOMMODATION_LETTER_SUCCESS:
      return {
        ...state,
        downloadingLetter: false,
      };
    case DOWNLOAD_STAFF_ACCOMMODATION_LETTER_ERROR:
      return {
        ...state,
        downloadingLetter: false,
        downloadingLetterError: "Failed to download letter",
      };

    // Download document
    case DOWNLOAD_ACCOMMODATION_DOCUMENT:
      return {
        ...state,
        downloadingDocument: true,
        downloadingDocumentError: null,
      };
    case DOWNLOAD_ACCOMMODATION_DOCUMENT_SUCCESS:
      return {
        ...state,
        downloadingDocument: false,
      };
    case DOWNLOAD_ACCOMMODATION_DOCUMENT_ERROR:
      return {
        ...state,
        downloadingDocument: false,
        downloadingDocumentError: "Failed to download document.",
      };

    // Statuses
    case LOAD_ACCOMMODATION_STATUSES:
      return {
        ...state,
        statuses: { ...state.statuses, loading: true, error: null },
      };
    case LOAD_ACCOMMODATION_STATUSES_SUCCESS:
      return {
        ...state,
        statuses: { data: action.payload, loading: false, error: null },
      };
    case LOAD_ACCOMMODATION_STATUSES_ERROR:
      return {
        ...state,
        statuses: { ...state.statuses, loading: false, error: "Failed to load statuses" },
      };

    // Document statuses
    case LOAD_ACCOMMODATION_DOCUMENT_STATUSES:
      return {
        ...state,
        documentStatuses: { ...state.documentStatuses, loading: true, error: null },
      };
    case LOAD_ACCOMMODATION_DOCUMENT_STATUSES_SUCCESS:
      return {
        ...state,
        documentStatuses: { data: action.payload, loading: false, error: null },
      };
    case LOAD_ACCOMMODATION_DOCUMENT_STATUSES_ERROR:
      return {
        ...state,
        documentStatuses: { ...state.documentStatuses, loading: false, error: "Failed to load document statuses" },
      };

    // Filters
    case SET_ACCOMMODATION_REQUESTS_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    // Reset state
    case RESET_STAFF_ACCOMMODATION_STATE:
      return initialState;

    // Clear detail
    case CLEAR_STAFF_ACCOMMODATION_REQUEST_DETAIL:
      return {
        ...state,
        requestDetail: { data: null, loading: false, error: null },
      };

    default:
      return state;
  }
};

export default staffAccommodationsReducer;
